import {styled} from "@mui/material/styles"
import Typography from "@mui/material/Typography"

export const AlphabetSection = styled(Typography)`
    background: ${({theme}) => theme.colours.utilities.backgroundAccent};
    font-family: ${({theme}) => theme.colours.typography.body3.fontFamily};
    font-weight: ${({theme}) => theme.colours.typography.body3.fontWeight};
    font-size: ${({theme}) => theme.colours.typography.body3.fontSize};
    line-height: ${({theme}) => theme.colours.typography.body3.lineHeight};
    letter-spacing: ${({theme}) => theme.colours.typography.body3.letterSpacing};
    top: 0;
    z-index: 1;
    padding: 0.65rem 1rem;
    min-height: 2.75rem;
`

export const TabbedFilterContainer = styled("div")`
    display: block;
`

export const PromotedBrandsContainer = styled(TabbedFilterContainer)``
